import { Box, styled } from "@mui/material";

export const Container = styled(Box)`
  position: relative;
  width: 64px;
  height: 64px;
  cursor: pointer;
  background-color: white;
  border: 2px solid white;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  box-shadow: ${({ theme }) => theme.shadows[2]};
  margin-block: ${({ theme }) => theme.spacing(1.5)};
  pointer-events: all;
`;

export const ImageContainer = styled(Box)`
  width: 60px;
  height: 60px;
  position: relative;
  padding-bottom: 0;
  border-radius: 4px;

  & img {
    width: 60px;
    height: 60px;
    object-fit: cover;
  }
`;

export const Label = styled(Box)`
  position: absolute;
  bottom: -2px;
  left: 4px;
  color: white;
  text-shadow: 1px 1px #444;
`;

export const StylePanel = styled(Box)`
  height: 160px;
  outline: 2px solid white;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background-color: white;
`;

export const StyleOptionBox = styled(Box)`
  margin: ${({ theme }) => theme.spacing(1)};
  padding-top: ${({ theme }) => theme.spacing(0.5)};
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};

    & img {
      outline-color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

export const StyleImage = styled("img")`
  height: 36px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  outline: 2px solid white;
`;

export const StyleOpacity = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.palette.background.default};
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  width: 100%;
`;
